import { Injectable } from '@angular/core';
import { EncryptStorage } from 'encrypt-storage';
import { environment } from '@environments/environment';


@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private encryptStorage 
  constructor() {
    this.encryptStorage = new EncryptStorage(environment.storageEncryptionKey, {
      storageType: 'sessionStorage',
    })
   }
  // Set the json data to local
  setJsonValue(key: string, value: any) {
    this.encryptStorage.setItem(key, value);
  }
  // Get the json value from local
  getJsonValue(key: string) {
    return this.encryptStorage.getItem(key);
  }// Clear the local
  clearStorage() {
    return this.encryptStorage.clear();
  }
}
